import {useEffect, useRef} from 'react';

/**
 * 滚动显现：IntersectionObserver（threshold 0.1）命中即给 .scroll-reveal 加 .visible，
 * 一次性触发、不 unobserve —— 与设计稿 js/main.js 的行为一致。
 * 老/受限浏览器无 IntersectionObserver 时直接全部置 visible，避免内容永久不可见。
 */
const useScrollReveal = <T extends HTMLElement>() => {
  const ref = useRef<T>(null);

  useEffect(() => {
    const root = ref.current;
    if (!root) return undefined;
    const elements = Array.from(root.querySelectorAll<HTMLElement>('.scroll-reveal'));
    if (!elements.length) return undefined;

    if (typeof IntersectionObserver === 'undefined') {
      elements.forEach((el) => el.classList.add('visible'));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      {threshold: 0.1},
    );
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return ref;
};

export default useScrollReveal;
